<box class="main-container" formName="DEPOSITDETAILFORM" tabindex="-1">
  <!-- <box class="trx-cover">
    <div class="trx-deposit-title">
      <h4>{{'DEPOSITDETAILFORM.depositDetails' | translate}}</h4>
    </div>
  </box> -->

  <div class="trx-details">
    <div class="trx-info-list">
      <div class="trx-info">
        <div class="info-feild">
          <span class="info-lbl">
            {{ "DEPOSITDETAILFORM.depositType" | translate }}</span
          >
          <span class="info-val">{{ popupData?.productDesc }} </span>
        </div>
        <div class="info-icon">
          <img
            src="./assets/images/download.gif"
            alt="loading..."
            (click)="_helper.downloadGICReceipt(popupData?.accountNumber)"
          />
        </div>
      </div>
      <div class="trx-details trx-detail-form">
        <ng-container>
          <box class="account-info">
            <span class="info-lbl">{{
              "DEPOSITDETAILFORM.depositAccountNumber" | translate
            }}</span>
            <span class="info-val">{{ popupData?.accountNumber}}</span>
          </box>
          <box class="account-info">
            <span class="info-lbl">{{
              "DEPOSITDETAILFORM.openDate" | translate
            }}</span>
            <span class="info-val">{{
              popupData?.effectiveDate | date: "dd/MM/yyyy"
            }}</span>
          </box>

          <box class="account-info">
            <span class="info-lbl">{{
              "DEPOSITDETAILFORM.noOfMonths" | translate
            }}</span>
            <ng-container *ngIf="popupData?.noOfMonths >= 1">
              <span class="info-val">{{ popupData?.noOfMonths }} Months</span>
            </ng-container>
            <ng-container *ngIf="popupData?.noOfDays >= 1">
              <span class="info-val">{{ popupData?.noOfDays }} Days</span>
            </ng-container>
          </box>

          <box class="account-info">
            <span class="info-lbl">
              {{ "DEPOSITDETAILFORM.interestRate" | translate }}</span
            >
            <span class="info-val">{{ popupData?.interestRate }} %</span>
          </box>
          <box class="account-info">
            <span class="info-lbl">{{
              "DEPOSITDETAILFORM.depositAmount" | translate
            }}</span>
            <span class="info-val">
              <span class="amount">{{ popupData?.depositAmount}}<span>{{popupData?.currency}}</span></span>
            </span>

          </box>
          <box class="account-info">
            <span class="info-lbl">{{
              "DEPOSITDETAILFORM.maturityAmount" | translate
            }}</span>
            <span class="info-val">
              <span class="amount">{{ popupData?.maturityAmount}}<span>{{popupData?.currency}}</span></span>
            </span>
          </box>
          <box class="account-info">
            <span class="info-lbl">{{
              "DEPOSITDETAILFORM.maturityDate" | translate
            }}</span>
            <span class="info-val">{{
              popupData?.maturityDate | date: "dd/MM/yyyy"
            }}</span>
          </box>
          <box class="account-info">
            <span class="info-lbl">{{
              "DEPOSITDETAILFORM.maturityInsDesc" | translate
            }}</span>
            <span class="info-val">{{ depositDetail.maturityDesc }}</span>
          </box>

          <box class="account-info">
            <span class="info-lbl">{{
              "DEPOSITDETAILFORM.debitAccountNumber" | translate
            }}</span>
            <span class="info-val">{{ depositDetail.debitAccountNumber }}</span>
          </box>
          <ng-container *ngIf="depositDetail.closureSettlementAccount != 0">
            <box class="account-info">
              <span class="info-lbl">{{
                "DEPOSITDETAILFORM.principalPaidAccount" | translate
              }}</span>
              <span class="info-val">{{
                depositDetail.closureSettlementAccount
              }}</span>
            </box>
          </ng-container>
          <!-- <box class="account-info">
                <span class="info-lbl">Nick Name</span>
                <span class="info-val">{{ state?.nickname?state?.nickname:popupData?.accountName}}
                  <button class="btn-link" >
                    <img (click)="edit()" src="./assets/images/content-icons/edit-pencil.svg"alt="edit_svg" height="28px" />

                </button>
                </span>
            </box> -->
        </ng-container>
      </div>
      <!-- <div class="trx-btn-grp">
        <ng-container *ngIf="popupData?.depositType == 'Redeemable'">

          <div class="redeem">
            <span
              class="redeem-link"
              (click)="redeem()">Redeem Deposit

              </span
            >
          </div>
        </ng-container>
        </div> -->
    </div>
  </div>

  <ng-template #loader>
    <div class="data-loading">
      <img src="./assets/images/data-loader.svg" alt="loading..." />
    </div>
  </ng-template>
</box>
